import React from "react";
import styled from "styled-components";
import {PROJECT_NAME, SUB_NAVIGATION_ITEMS, TUTORIAL} from "modules";
import {Exist} from "components/Exist";
import {SubLink} from "./SubLink";
import {TutorialLink} from "./TutorialLink";
import {Box} from "@mui/material";
import {media} from "assets/css/media";

const Wrapper = styled.div`
	box-sizing: border-box;
	height: 64px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding-left: 58px;
	padding-right: 40px;
	background: ${({theme}) => theme.global.header_sub_nav_background};

	a {
		margin-right: 20px;
		margin-left: 20px;
		color: #fff;
		font-weight: 500;
	}

	@media screen and (max-width: ${media.large_desktop}) {
		padding-left: 8px;
	}
`;

const Dropdown = styled.div`
	position: absolute;
	bottom: 8px;
	left: 0;
	display: none;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	transform: translateY(100%);
	background: ${({theme}) => theme.global.header_background};
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 10px;

	a {
		position: relative;
		padding: 10px 20px;
		font-weight: 500;
		font-size: 14px;
		line-height: 160%;
		color: #ffffff;
		white-space: nowrap;
		margin: 0;
		width: 100%;

		&:hover,
		&:active,
		&:focus {
			background: ${({theme}) => theme.global.header_dropdown_hover_color};
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
`;

const LinkWrapper = styled.div`
	position: relative;

	> a {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;

		&:after {
			content: "";
			transition: width ease-in-out 250ms;
			position: absolute;
			width: 0;
			left: 50%;
			transform: translateX(-50%);
			bottom: 14px;
			height: 3px;
			background: #fff;
		}

		&.active:after {
			width: calc(100% - 40px);
		}
	}

	&:hover {
		> a:after {
			width: calc(100% - 40px);
		}

		${Dropdown} {
			display: flex;
		}
	}
`;

export const DesktopSubNavigation: React.FC = () => {
	return (
		<Wrapper>
			<Box
				sx={{
					display: "flex",
				}}>
				{SUB_NAVIGATION_ITEMS.map((item) => (
					<React.Fragment key={item.name}>
						<LinkWrapper>
							<SubLink item={item} />
							<Exist when={Boolean(item.subItems?.length)}>
								<Dropdown>
									{item.subItems?.map((item) => (
										<SubLink key={item.name} item={item} />
									))}
								</Dropdown>
							</Exist>
						</LinkWrapper>
					</React.Fragment>
				))}
			</Box>
			<Exist when={TUTORIAL[PROJECT_NAME]}>
				<TutorialLink />
			</Exist>
		</Wrapper>
	);
};
